/*
  <gift-with-purchase> for the gift with purchase block (snippets/gift-with-purchase.liquid).

  - Add free gift: posts the form to /cart/add.js with the drawer's sections and re-renders the drawer
    (or reloads the cart page). The gift is only ever added by this click, never automatically.
  - Keeps the gift honest: the snippet marks the element with data-remove-key when the gift is in the cart
    below the threshold (removed) or data-fix-quantity-key when its quantity is above 1 (set back to 1).
    The drawer is re-rendered with innerHTML after every cart change, which does not run inline scripts, so
    the element's connectedCallback is what runs on every re-render.
*/
(function () {
  if (customElements.get('gift-with-purchase')) return;

  // One request at a time, and never retry a key/action that already failed on this page.
  var busy = false;
  var failed = {};

  class GiftWithPurchase extends HTMLElement {
    connectedCallback() {
      var form = this.querySelector('[data-gwp-form]');
      if (form) form.addEventListener('submit', this.onSubmit.bind(this, form));

      if (this.dataset.removeKey) this.changeLine(this.dataset.removeKey, 0);
      else if (this.dataset.fixQuantityKey) this.changeLine(this.dataset.fixQuantityKey, 1);
    }

    sectionsParams() {
      var drawer = this.closest('cart-drawer');
      if (!drawer) return {};
      return {
        sections: drawer
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(','),
        sections_url: window.location.pathname,
      };
    }

    render(response) {
      var drawer = this.closest('cart-drawer');
      if (drawer) {
        drawer.renderContents(response);
      } else {
        window.location.reload();
      }
    }

    showError(message) {
      var error = this.querySelector('[data-gwp-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    onSubmit(form, event) {
      event.preventDefault();
      if (busy) return;
      busy = true;

      var button = form.querySelector('button[type="submit"]');
      var data = new FormData(form);
      var variantId = data.get('id');
      var body = {
        items: [{ id: Number(variantId), quantity: 1, properties: { __type: 'GWP' } }],
      };
      Object.assign(body, this.sectionsParams());

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      var errorElement = this.querySelector('[data-gwp-error]');
      if (errorElement) errorElement.hidden = true;

      var self = this;
      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok || result.json.status) {
            throw new Error(result.json.description || result.json.message || 'Could not add the gift');
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'gift-with-purchase',
              productVariantId: variantId,
              cartData: result.json,
            });
          }
          self.render(result.json);
        })
        .catch(function (error) {
          console.error(error);
          self.showError(error.message);
          if (button) {
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }
        })
        .then(function () {
          busy = false;
        });
    }

    changeLine(key, quantity) {
      var attempt = key + ':' + quantity;
      if (busy || failed[attempt]) return;
      busy = true;

      var body = { id: key, quantity: quantity };

      var self = this;
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not update the gift');
          return response.json();
        })
        .then(function () {
          // refresh() re-renders the drawer without opening it, so a stale gift removed on page load is quiet.
          var drawer = self.closest('cart-drawer');
          if (drawer) drawer.refresh();
          else window.location.reload();
        })
        .catch(function (error) {
          console.error(error);
          failed[attempt] = true;
        })
        .then(function () {
          busy = false;
        });
    }
  }

  customElements.define('gift-with-purchase', GiftWithPurchase);
})();
